var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8080fe4739a4df1793c8a2e033bd305b5ce9513e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@protege"]={id:"8080fe4739a4df1793c8a2e033bd305b5ce9513e"};
      